import { mpEventInfo } from '@/constant'
import type { DefaultResponse, Pagination } from '@/types/common'
import maxios from '@/utils/axios/maxios'

type TeachersResponse = Pagination<res.Teacher[]>
type TeacherResponse = DefaultResponse<res.Teacher>

// 선생님 API
const teacherApi = {
  // 선생님 가져오기
  getTeachers(pageQueryString: string) {
    return maxios.get<TeachersResponse>(`/teachers${pageQueryString}`, {
      params: { mp_event_name: mpEventInfo.선생님조회 },
    })
  },
  // 특정 선생님 가져오기
  getOneTeacher(teacherId: req.TeacherId) {
    return maxios.get<TeacherResponse>(`/teachers/${teacherId}`, {
      params: { mp_event_name: mpEventInfo.특정선생님조회 },
    })
  },
  // 특정 선생님의 난이도 설정 가져오기
  getTeacherSetting: () => {
    return maxios.get<DefaultResponse<res.TeacherSetting>>(`/teachers/setting`, {
      params: { mp_event_name: mpEventInfo['학습지만들기1단계_난이도설정(무조건발생)'] },
    })
  },
  // 선생님 생성하기
  postTeacher: (teacher: req.CreateTeacher) => {
    return maxios.post('/teachers', teacher, {
      params: { mp_event_name: mpEventInfo.선생님등록 },
    })
  },
  // 특정 선생님의 난이도 설정 변경하기
  postTeacherSetting: (data: req.TeacherSetting) => {
    return maxios.post(`/teachers/setting`, data, {
      params: { mp_event_name: mpEventInfo['학습지만들기1단계_난이도설정수정'] },
    })
  },
  // 특정 선생님 수정하기
  patchTeacher(id: string, teacher: req.PatchTeacher) {
    return maxios.patch(`/teachers/${id}`, teacher, {
      params: { mp_event_name: mpEventInfo.특정선생님수정 },
    })
  },
  // 특정 선생님 삭제하기
  deleteTeachers(teacherIds: req.TeacherId[]) {
    return maxios({
      url: '/teachers',
      method: 'DELETE',
      data: teacherIds,
      params: { mp_event_name: mpEventInfo.여러선생님삭제 },
    })
  },
  // 반별정렬로 학생들 번호 가져오기
  patchPassword(params: req.InitTeacherPassword) {
    return maxios.patch('/password', params, {
      params: { mp_event_name: mpEventInfo.학생학부모비번수정 },
    })
  },
  getActivityCount() {
    return maxios.get<res.ActivityCount>(`/teachers/activity-counts`)
  },
}

export default teacherApi
